"use client";

import { Button } from "@/components/ui/button";
import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import qs from "query-string";

type CategoryItemProps = {
  categoryId: string | null;
  categoryTitle: string;
};

export default function CategoryItem({ categoryId, categoryTitle }: CategoryItemProps) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const isSelected = categoryId === searchParams.get("categoryId");

  const newUrl = qs.stringifyUrl(
    {
      url: pathname,
      query: {
        categoryId: isSelected ? null : categoryId,
        query: searchParams.get("query"),
      },
    },
    { skipEmptyString: true, skipNull: true },
  );

  return (
    <li>
      <Button
        variant="outline"
        size="sm"
        className={isSelected ? "border-0 bg-courseAccent text-darkGray" : ""}
        asChild
      >
        <Link href={newUrl} scroll={false}>
          {categoryTitle}
        </Link>
      </Button>
    </li>
  );
}
